module.exports = __webpack_public_path__ + "img/private-napolimania-pizza-1.6010b819.jpg";